import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CloseNotification from "@MasterBluePrint/Icons/CloseNotification";
import ErrorNotification from "@MasterBluePrint/Icons/ErrorNotification";
import InformationNotification from "@MasterBluePrint/Icons/InformationNotification";
import SuccessNotification from "@MasterBluePrint/Icons/SuccessNotification";
import WarningNotification from "@MasterBluePrint/Icons/WarningNotification";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    fields: {
        messageText: string;
        messageIcon: string;
        notificationDays: string;
    };
}

type Props = OwnProps;

export interface NotificationStyles {
    errorNotificationCSS?: InjectableCss;
}

export const notificationStyles: NotificationStyles = {
    errorNotificationCSS: {
        css: css`
            @media (max-width: 767px) {
                display: block;
            }
            display: flex;
            flex-wrap: wrap;
            padding-top: .75rem;
            max-width: 90%;
            margin: .5rem 1rem 0 0;
        `,
    },
};

const styles = notificationStyles;

class SiteMessage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.state = {
            show: true,
        };
    }

    closeSiteMessage = () => {
        this.setState({ show: false });
        setCookie("closeSiteMessage", "true", { expires: parseInt(this.props.fields.notificationDays) });
    };

    render() {
        if (!getCookie("closeSiteMessage")) {
            let icon = ErrorNotification;
            if (this.props.fields.messageIcon === "WarningNotification") {
                icon = WarningNotification;
                return (
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            minWidth: "18rem",
                            height: "auto",
                            minHeight: "3rem",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                            color: "#333f48",
                            background: "rgba(155, 148, 0, .1)",
                            borderLeft: "3px solid #ff9400",
                            borderRight: "1px solid rgba(155, 148, 0, .5)",
                            borderBottom: "1px solid rgba(155, 148, 0, .5)",
                            borderTop: "1px solid rgba(155, 148, 0, .5)",
                            display: "flex",
                            alignItems: "flex-start",
                        }}
                    >
                        <div style={{ display: "flex", margin: "0 0 0 1rem" }}>
                            <Icon
                                src={icon}
                                css={css`
                                    margin-right: 1rem;
                                    margin-top: .875rem;
                                    flex-shrink: 0;
                                `}
                                style={{ fill: "#ff9400" }}
                            />
                            {}
                        </div>

                        <StyledWrapper {...styles.errorNotificationCSS}>
                            <div
                                style={{
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    lineHeight: "1.29",
                                    letterSpacing: ".16px",
                                    margin: "0 1rem 0 0",
                                    fontFamily: "Lato, sans-serif",
                                }}
                            >
                                <Typography>Warning notification</Typography>
                            </div>

                            <div
                                style={{
                                    fontSize: "1rem",
                                    fontWeight: 400,
                                    lineHeight: "1.29",
                                    letterSpacing: ".16px",
                                    wordBreak: "break-word",
                                    fontFamily: "Lato, sans-serif",
                                }}
                            >
                                <Typography>{parse(this.props.fields.messageText, parserOptions)}</Typography>
                            </div>
                        </StyledWrapper>
                        <Icon
                            onClick={this.closeSiteMessage}
                            src={CloseNotification}
                            css={css`
                    outline: 2px solid transparent;
                    outline-offset: -.125rem;
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: flex;                   
                    flex-direction: column;                   
                    align-items: center;                    
                    justify-content: center;
                    width: 3rem;
                    min-width: 3rem;
                    max-width: 3rem;
                    height: 3rem;
                    padding: 0;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    transition: outline 110ms cubic-bezier(.2, 0, .38, .9),
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    fill: #c63527;
                    `}
                        />
                        {}
                    </div>
                );
            }
            if (this.props.fields.messageIcon === "SuccessNotification") {
                icon = SuccessNotification;
                return (
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            minWidth: "18rem",
                            height: "auto",
                            minHeight: "3rem",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                            color: "#333f48",
                            background: "rgba(45, 137, 0, .1)",
                            borderLeft: "3px solid #1e5901",
                            borderRight: "1px solid rgba(45, 137, 0, .5)",
                            borderBottom: "1px solid rgba(45, 137, 0, .5)",
                            borderTop: "1px solid rgba(45, 137, 0, .5)",
                            display: "flex",
                            alignItems: "flex-start",
                        }}
                    >
                        <div style={{ display: "flex", margin: "0 0 0 1rem" }}>
                            <Icon
                                src={icon}
                                css={css`
                                    margin-right: 1rem;
                                    margin-top: .875rem;
                                    flex-shrink: 0;
                                `}
                                style={{ fill: "#1e5901" }}
                            />
                            {}
                        </div>

                        <StyledWrapper {...styles.errorNotificationCSS}>
                            <div
                                style={{
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    lineHeight: "1.29",
                                    letterSpacing: ".16px",
                                    margin: "0 1rem 0 0",
                                    fontFamily: "Lato, sans-serif",
                                }}
                            >
                                <Typography>Success notification</Typography>
                            </div>

                            <div
                                style={{
                                    fontSize: "1rem",
                                    fontWeight: 400,
                                    lineHeight: "1.29",
                                    letterSpacing: ".16px",
                                    wordBreak: "break-word",
                                    fontFamily: "Lato, sans-serif",
                                }}
                            >
                                <Typography>{parse(this.props.fields.messageText, parserOptions)}</Typography>
                            </div>
                        </StyledWrapper>

                        <Icon
                            onClick={this.closeSiteMessage}
                            src={CloseNotification}
                            css={css`
                    outline: 2px solid transparent;
                    outline-offset: -.125rem;
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: flex;                   
                    flex-direction: column;                   
                    align-items: center;                    
                    justify-content: center;
                    width: 3rem;
                    min-width: 3rem;
                    max-width: 3rem;
                    height: 3rem;
                    padding: 0;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    transition: outline 110ms cubic-bezier(.2, 0, .38, .9),
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    fill: #1e5901;
                    `}
                        />
                        {}
                    </div>
                );
            }
            if (this.props.fields.messageIcon === "InformationNotification") {
                icon = InformationNotification;

                return (
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            minWidth: "18rem",
                            height: "auto",
                            minHeight: "3rem",
                            marginTop: "1rem",
                            color: "#333f48",
                            background: "rgba(0, 156, 222, .1)",
                            borderLeft: "3px solid #2060ad",
                            borderRight: "1px solid rgba(0, 156, 222, .5)",
                            borderBottom: "1px solid rgba(0, 156, 222, .5)",
                            borderTop: "1px solid rgba(0, 156, 222, .5)",
                            display: "flex",
                            alignItems: "flex-start",
                        }}
                    >
                        <div style={{ display: "flex", margin: "0 0 0 1rem" }}>
                            <Icon
                                src={icon}
                                css={css`
                                    margin-right: 1rem;
                                    margin-top: .875rem;
                                    flex-shrink: 0;
                                `}
                                style={{ fill: "#2060ad" }}
                            />
                            {}
                        </div>

                        <StyledWrapper {...styles.errorNotificationCSS}>
                            <div
                                style={{
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    lineHeight: "1.29",
                                    letterSpacing: ".16px",
                                    margin: "0 1rem 0 0",
                                    fontFamily: "Lato, sans-serif",
                                }}
                            >
                                <Typography>Information notification</Typography>
                            </div>

                            <div
                                style={{
                                    fontSize: "1rem",
                                    fontWeight: 400,
                                    lineHeight: "1.29",
                                    letterSpacing: ".16px",
                                    wordBreak: "break-word",
                                    fontFamily: "Lato, sans-serif",
                                }}
                            >
                                <Typography>{parse(this.props.fields.messageText, parserOptions)}</Typography>
                            </div>
                        </StyledWrapper>

                        <Icon
                            onClick={this.closeSiteMessage}
                            src={CloseNotification}
                            css={css`
                    outline: 2px solid transparent;
                    outline-offset: -.125rem;
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: flex;                   
                    flex-direction: column;                   
                    align-items: center;                    
                    justify-content: center;
                    width: 3rem;
                    min-width: 3rem;
                    max-width: 3rem;
                    height: 3rem;
                    padding: 0;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    transition: outline 110ms cubic-bezier(.2, 0, .38, .9),
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    fill: #2060ad;
                    `}
                        />
                        {}
                    </div>
                );
            }

            return (
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        minWidth: "18rem",
                        height: "auto",
                        minHeight: "3rem",
                        marginTop: "1rem",
                        marginBottom: "1rem",
                        color: "#333f48",
                        background: "rgba(198, 53, 39, .1)",
                        borderLeft: "3px solid #c63527",
                        borderRight: "1px solid rgba(198, 53, 39, .5)",
                        borderBottom: "1px solid rgba(198, 53, 39, .5)",
                        borderTop: "1px solid rgba(198, 53, 39, .5)",
                        display: "flex",
                        alignItems: "flex-start",
                    }}
                >
                    <div style={{ display: "flex", margin: "0 0 0 1rem" }}>
                        <Icon
                            src={icon}
                            css={css`
                                margin-right: 1rem;
                                margin-top: .875rem;
                                flex-shrink: 0;
                            `}
                            style={{ fill: "#c63527" }}
                        />
                        {}
                    </div>

                    <StyledWrapper {...styles.errorNotificationCSS}>
                        <div
                            style={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                lineHeight: "1.29",
                                letterSpacing: ".16px",
                                margin: "0 1rem 0 0",
                                fontFamily: "Lato, sans-serif",
                            }}
                        >
                            <Typography>Error notification</Typography>
                        </div>

                        <div
                            style={{
                                fontSize: "1rem",
                                fontWeight: 400,
                                lineHeight: "1.29",
                                letterSpacing: ".16px",
                                wordBreak: "break-word",
                                fontFamily: "Lato, sans-serif",
                            }}
                        >
                            <Typography>{parse(this.props.fields.messageText, parserOptions)}</Typography>
                        </div>
                    </StyledWrapper>

                    <Icon
                        onClick={this.closeSiteMessage}
                        src={CloseNotification}
                        css={css`
                    outline: 2px solid transparent;
                    outline-offset: -.125rem;
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: flex;                   
                    flex-direction: column;                   
                    align-items: center;                    
                    justify-content: center;
                    width: 3rem;
                    min-width: 3rem;
                    max-width: 3rem;
                    height: 3rem;
                    padding: 0;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    transition: outline 110ms cubic-bezier(.2, 0, .38, .9),
                    background-color 110ms cubic-bezier(.2, 0, .38, .9);
                    fill: #c63527;
                    `}
                    />
                    {}
                </div>
            );
        }

        return <div></div>;
    }
}

const widgetModule: WidgetModule = {
    component: SiteMessage,
    definition: {
        fieldDefinitions: [
            {
                name: "messageText",
                fieldType: "Translatable",
                editorTemplate: "RichTextField",
                defaultValue: "",
                isRequired: true,
                displayName: "Message",
            },
            {
                name: "messageIcon",
                fieldType: "General",
                editorTemplate: "DropDownField",
                defaultValue: "ErrorNotification",
                displayName: "Template",
                options: [
                    { displayName: "Error Notification", value: "ErrorNotification" },
                    { displayName: "Information Notification", value: "InformationNotification" },
                    { displayName: "Success Notification", value: "SuccessNotification" },
                    { displayName: "Warning Notification", value: "WarningNotification" },
                ],
                isRequired: true,
            },
            {
                name: "notificationDays",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                displayName: "Number of days the notification stays closed",
                defaultValue: "1",
                isRequired: true,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
